// extracted by mini-css-extract-plugin
export var linkText = "_r5-0";